export const WatchlistType = {
    ALL: 'ALL',
    MOVIES: 'MOVIES',
    SERIES: 'SERIES',
} as const;

export type WatchlistTypeValue = (typeof WatchlistType)[keyof typeof WatchlistType];

export const ContentType = {
    VOD_ASSET: 'VOD_ASSET',
    PROGRAM: 'PROGRAM',
    PROGRAM_SERIES: 'PROGRAM_SERIES',
    VOD_SERIES: 'VOD_SERIES',
} as const;

export type ContentTypeValue = (typeof ContentType)[keyof typeof ContentType];

export interface ContentItem {
    id: string;
    title: string;
    title_original?: string;
    description?: string;
    image_url?: string;
    background_image_url?: string;
    tagline?: string;
    genres?: string[];
    category?: string;
    kind?: string;
    duration?: number;
    release_year?: number | null;
    imdb_rating?: number | null;
    episode_number?: number | null;
    episode_title?: string;
    episode_title_original?: string;
    season_number?: number | null;
    production_countries?: string[];
    program_series_id?: string | null;
    vod_series_id?: string | null;
    channel_id?: string;
    has_trailer?: boolean;
    adult_content?: boolean;
    max_quality?: string;
}

export interface ParsedWatchlistItem {
    id: string;
    title: string;
    image: string;
    background_image_url: string;
    description: string;
    tagline: string;
    metaData: string;
    genres: string[];
    category: string;
    duration?: number;
    isPortrait: boolean;
    kind?: string;
    channelId?: string;
    type: string;
    release_year?: number | null;
    imdb_rating?: number | null;
    watchlistItem: true;
}

export interface ResultItem {
    type: ContentTypeValue;
    title: string;
    image_url?: string;
    item: ContentItem;
}

export interface WatchlistResponse {
    results: ResultItem[];
    count: number;
    pages: number;
    image_aspect_ratio: string;
    watchlist_type?: WatchlistTypeValue;
}

export type WatchlistFetcher = (params: any) => Promise<WatchlistResponse>;
